// extracted by mini-css-extract-plugin
export default {"redirectButton":"ClubRegistrationDashboardRedirect_redirectButton__-KKUS","active":"ClubRegistrationDashboardRedirect_active__1aO1X"};